/* assets/jtpl-qty.js — product page only (no cart drawer) */
(() => {
  if (window.__JTPL_QTY_PP_ATTACHED__) return;
  window.__JTPL_QTY_PP_ATTACHED__ = true;

  // ---------- Helpers ----------
  function formatMoney(cents) {
    const amount = (Number(cents) || 0) / 100;
    const formatted = amount.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return `€${formatted} EUR`;
  }

  function normalizeToStep(value, min, max, step) {
    let v = Number(value);
    if (isNaN(v)) v = Number(min) || 0;
    if (min !== '' && min != null && !isNaN(min)) v = Math.max(v, Number(min));
    if (max !== '' && max != null && !isNaN(max)) v = Math.min(v, Number(max));
    const base = Number(min) || 0;
    const s = Number(step) || 1;
    v = Math.round((v - base) / s) * s + base;
    return v;
  }

  function normalizeToRule(units, ruleMin, ruleMax, ruleInc) {
    let v = Number(units);
    if (isNaN(v)) v = Number(ruleMin) || 1;
    if (ruleMin != null && ruleMin !== '' && !isNaN(ruleMin)) v = Math.max(v, Number(ruleMin));
    if (ruleMax != null && ruleMax !== '' && !isNaN(ruleMax)) v = Math.min(v, Number(ruleMax));
    const base = Number(ruleMin) || 0;
    const inc = Number(ruleInc) || 1;
    v = Math.round((v - base) / inc) * inc + base;
    return Math.max(1, Math.round(v)); // Shopify expects integers
  }

  // ---------- calc-price ----------
  function resolveCalc(scope) {
    const inScope = scope.querySelector('.calc-price');
    if (inScope) return inScope;
    const root =
      scope.closest('.product, .product__info, section, article, form, .card, .grid__item') || document;
    return root.querySelector('.calc-price');
  }

  function updateCalc(scope, cmVal) {
    const calc = resolveCalc(scope);
    if (!calc) return;
    const base = Number(calc.dataset.basePrice) || 0; // cents
    const step = Number(calc.dataset.unitStep) || 1;  // e.g., 10 cm per unit
    const cmNode = calc.querySelector('.cm');
    if (cmNode) cmNode.textContent = cmVal;
    const units = (Number(cmVal) || 0) / step;
    const total = Math.round(base * units);
    const priceNode = calc.querySelector('.price');
    if (priceNode) priceNode.textContent = formatMoney(total);
  }

  function unitStep(scope, cm) {
    const calc = resolveCalc(scope);
    if (calc && calc.dataset.unitStep) return Number(calc.dataset.unitStep) || 1;
    return Number(cm?.step || 1);
  }

  // ---------- Product page sync ----------
  function pp_getEls(scope) {
    const cm   = scope.querySelector('[data-quantity-input-centimeter]');
    const real = scope.querySelector('[data-quantity-input-real]') ||
                 scope.querySelector('input[name="quantity"][type="hidden"]') ||
                 scope.querySelector('[data-quantity-input]:not([type="number"])');
    return { cm, real };
  }

  function pp_getRules(real) {
    if (!real) return { min:1, inc:1, max:null };
    const min = real.getAttribute('min');
    const inc = real.getAttribute('step');
    const max = real.getAttribute('max');
    return {
      min: min === null || min === '' ? null : Number(min),
      inc: inc === null || inc === '' ? 1    : Number(inc),
      max: max === null || max === '' ? null : Number(max),
    };
  }

  // cm (visual) -> real (hidden Shopify quantity)
  function pp_syncFromCm(scope) {
    const { cm, real } = pp_getEls(scope);
    if (!cm || !real) return;
    const uStep = unitStep(scope, cm);
    const cmNorm = normalizeToStep(cm.value, cm.min, cm.max, cm.step || uStep);
    if (String(cmNorm) !== String(cm.value)) cm.value = cmNorm;
    const rs = pp_getRules(real);
    const units = Number(cmNorm) / uStep;
    real.value = normalizeToRule(units, rs.min, rs.max, rs.inc);
    updateCalc(scope, cmNorm);
  }

  // real (hidden) -> cm (visual)
  function pp_syncFromReal(scope) {
    const { cm, real } = pp_getEls(scope);
    if (!cm || !real) return;
    const uStep = unitStep(scope, cm);
    const rs = pp_getRules(real);
    const u = normalizeToRule(real.value, rs.min, rs.max, rs.inc);
    const cmRaw = u * uStep;
    const cmNorm = normalizeToStep(cmRaw, cm.min, cm.max, cm.step);
    cm.value = cmNorm;
    updateCalc(scope, cmNorm);
  }

  function pp_findScopeFromEventTarget(t) {
    const scope = t.closest('[data-jtpl-qty-scope]');
    if (!scope) return null;
    // Explicitly ignore anything inside cart-related containers (just in case)
    if (t.closest('.cart-drawer, .mini-cart')) return null;
    return scope;
  }

  // ---------- Delegated listeners (product page only) ----------
  document.addEventListener('input', (e) => {
    const scope = pp_findScopeFromEventTarget(e.target);
    if (!scope) return;
    if (e.target.matches('[data-quantity-input-centimeter]')) pp_syncFromCm(scope);
    if (e.target.matches('[data-quantity-input-real]'))       pp_syncFromReal(scope);
    if (e.target.matches('input[name="quantity"][type="hidden"]')) pp_syncFromReal(scope);
  });

  document.addEventListener('change', (e) => {
    const scope = pp_findScopeFromEventTarget(e.target);
    if (!scope) return;
    if (e.target.matches('[data-quantity-input-centimeter]')) pp_syncFromCm(scope);
    if (e.target.matches('[data-quantity-input-real]'))       pp_syncFromReal(scope);
    if (e.target.matches('input[name="quantity"][type="hidden"]')) pp_syncFromReal(scope);
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-quantity-increase],[data-quantity-decrease]');
    if (!btn) return;
    const scope = pp_findScopeFromEventTarget(btn);
    if (!scope) return;
    e.preventDefault();

    // Prefer controlling the visible cm input if it exists
    const cm   = scope.querySelector('[data-quantity-input-centimeter]');
    const real = scope.querySelector('[data-quantity-input-real]') ||
                 scope.querySelector('input[name="quantity"][type="hidden"]');
    const target = cm || real;
    if (!target) return;

    const isInc = btn.hasAttribute('data-quantity-increase');
    const step  = Number(target.step || 1);
    const min   = target.min === '' ? null : Number(target.min);
    const max   = target.max === '' ? null : Number(target.max);
    let v = Number(target.value); if (isNaN(v)) v = min ?? 0;
    v = isInc ? v + step : v - step;
    if (min != null) v = Math.max(v, min);
    if (max != null) v = Math.min(v, max);
    target.value = v;

    if (target === cm) pp_syncFromCm(scope);
    else pp_syncFromReal(scope);
  });

  // ---------- Init / on section render ----------
  function initAll() {
    document.querySelectorAll('[data-jtpl-qty-scope]').forEach((scope) => {
      const { cm, real } = pp_getEls(scope);
      if (cm) pp_syncFromCm(scope);
      else if (real) pp_syncFromReal(scope);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:reorder', initAll);
})();


// --- JTPL Cart CM plugin (with theme preloader toggle) ---
(function jtplCartCmPlugin(){
  if (window.__JTPL_CART_CM_ATTACHED__) return;
  window.__JTPL_CART_CM_ATTACHED__ = true;

  function toInt(n, fallback = 0) {
    const v = Number(n);
    return Number.isFinite(v) ? Math.trunc(v) : fallback;
  }

  function normalizeQty(qty, min, max, step) {
    let v = toInt(qty, 0);
    const s = Math.max(1, toInt(step, 1));
    const mi = (min == null || min === '') ? 0 : toInt(min, 0);
    const ma = (max == null || max === '' || isNaN(max)) ? null : toInt(max);

    if (v < mi) v = mi;
    if (ma !== null && v > ma) v = ma;
    v = mi + Math.floor((v - mi) / s) * s;
    if (v < mi) v = mi;
    if (ma !== null && v > ma) v = ma;
    return v;
  }

  function getFields(scope) {
    const cmInput   = scope.querySelector('[data-quantity-input-centimeter]');
    const realInput = scope.querySelector('[data-quantity-input-real]');
    if (!cmInput || !realInput) return null;

    const unitStep = toInt(realInput.getAttribute('data-unit-step') || 10, 10);
    const min      = toInt(realInput.getAttribute('min')  || 1, 1);
    const step     = toInt(realInput.getAttribute('step') || 1, 1);
    const maxAttr  = realInput.getAttribute('max');
    const max      = (maxAttr == null || maxAttr === '') ? null : toInt(maxAttr);
    const itemKey  = realInput.getAttribute('data-item-key');

    return { cmInput, realInput, unitStep, min, max, step, itemKey };
  }

  function setCmValue(fields, newCm) {
    if (!fields) return;
    const minCm   = Math.max(50, toInt(fields.cmInput.getAttribute('min') || 50));
    const stepCm  = Math.max(1, toInt(fields.cmInput.getAttribute('step') || 10));
    const maxAttr = fields.cmInput.getAttribute('max');
    const maxCm   = (maxAttr == null || maxAttr === '') ? null : toInt(maxAttr);

    let v = toInt(newCm, minCm);
    if (v < minCm) v = minCm;
    if (maxCm !== null && v > maxCm) v = maxCm;
    v = minCm + Math.floor((v - minCm) / stepCm) * stepCm;

    fields.cmInput.value = String(v);
  }

  // Find the nearest preloader to scope (prefer inside drawer)
  function findPreloader(scope) {
    const drawer = scope.closest('.cart-drawer, [data-cart-drawer], .mini-cart, [data-cart-panel]');
    return (drawer && drawer.querySelector('.preloader-wrapper.js-preloader')) ||
           document.querySelector('.preloader-wrapper.js-preloader');
  }

  // Toggle theme preloader .is-active
  function withPreloader(scope, run) {
    const EB = window?.themeCore?.EventBus;
    const pre = findPreloader(scope);
    let off = null;

    if (pre) pre.classList.add('is-active');

    // also listen to cart:updated to clear loader ASAP
    if (EB && EB.listen) {
      const handler = () => {
        if (pre) pre.classList.remove('is-active');
        EB.remove && EB.remove('cart:updated', handler);
      };
      EB.listen('cart:updated', handler);
      off = () => { EB.remove && EB.remove('cart:updated', handler); };
    }

    const done = () => {
      off && off();
      if (pre) pre.classList.remove('is-active');
    };

    return Promise.resolve()
      .then(run)
      .finally(done);
  }

  async function applyCmToCart(scope) {
    const CartApi = window?.themeCore?.CartApi;
    if (!CartApi) return; // Sprout core not ready—silently skip

    const fields = getFields(scope);
    if (!fields || !fields.itemKey) return;

    // cm -> desired real units
    const cm = toInt(fields.cmInput.value, 50);
    const desiredReal = Math.round(cm / fields.unitStep);

    // snap to variant rules
    const normalizedReal = normalizeQty(desiredReal, fields.min, fields.max, fields.step);

    // reflect back in cm UI and hidden real input
    setCmValue(fields, normalizedReal * fields.unitStep);
    fields.realInput.value = String(normalizedReal);
    fields.realInput.dispatchEvent(new Event('input', { bubbles: true }));
    fields.realInput.dispatchEvent(new Event('change', { bubbles: true }));

    // call CartApi wrapped with preloader toggle
    return withPreloader(scope, async () => {
      const SECTIONS = "cart-template,cart-drawer";
      await CartApi.makeRequest(
        CartApi.actions.CHANGE_CART_ITEM_QUANTITY,
        fields.itemKey,
        normalizedReal,
        SECTIONS
      );
    });
  }

  function bindListeners() {
    // +/- buttons
    document.addEventListener('click', function(e) {
      const scope = e.target.closest('.quantity[data-jtpl-cart-scope="true"]');
      if (!scope) return;

      const fields = getFields(scope);
      if (!fields) return;

      const isMinus = e.target.closest('[data-quantity-decrease]');
      const isPlus  = e.target.closest('[data-quantity-increase]');
      if (!isMinus && !isPlus) return;

      e.preventDefault();

      const stepCm = Math.max(1, toInt(fields.cmInput.getAttribute('step') || 10));
      const currentCm = toInt(fields.cmInput.value, 50);
      const nextCm = currentCm + (isPlus ? stepCm : -stepCm);

      fields.cmInput.value = String(nextCm);
      applyCmToCart(scope);
    }, { passive: false });

    // direct cm edit: snap on input, apply on change
    document.addEventListener('input', function(e) {
      const cmInput = e.target.closest('[data-quantity-input-centimeter]');
      if (!cmInput) return;
      const scope = cmInput.closest('.quantity[data-jtpl-cart-scope="true"]');
      if (!scope) return;

      const fields = getFields(scope);
      if (!fields) return;
      setCmValue(fields, toInt(fields.cmInput.value, 50));
    });

    document.addEventListener('change', function(e) {
      const cmInput = e.target.closest('[data-quantity-input-centimeter]');
      if (!cmInput) return;
      const scope = cmInput.closest('.quantity[data-jtpl-cart-scope="true"]');
      if (!scope) return;
      applyCmToCart(scope);
    });

    // section events not needed; listeners are delegated
  }

  window.initJtplCartCm = function initJtplCartCm(){ return true; };

  function ready(fn){ document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn(); }
  ready(() => {
    if (!window?.themeCore?.CartApi) {
      const i = setInterval(() => {
        if (window?.themeCore?.CartApi) {
          clearInterval(i);
          bindListeners();
        }
      }, 50);
      setTimeout(() => clearInterval(i), 8000);
    } else {
      bindListeners();
    }
  });
})();
